import { render, staticRenderFns } from "./ActionStockLow.vue?vue&type=template&id=7c10b3db&scoped=true&"
import script from "./ActionStockLow.vue?vue&type=script&lang=js&"
export * from "./ActionStockLow.vue?vue&type=script&lang=js&"
import style0 from "./ActionStockLow.vue?vue&type=style&index=0&id=7c10b3db&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c10b3db",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextarea})
